// eslint-disable-next-line import/prefer-default-export
export var required = function required(value) {
  return !!value || 'Field is required';
};